import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { Button } from "../../ui";

interface SidebarItemProps {
  faIcon?: IconProp;
  imgSrc?: string;
  label: string;
  showArrow?: boolean;
  onClick?: () => void;
}

export function SidebarItem({
  faIcon,
  imgSrc,
  label,
  onClick,
  showArrow = false,
}: SidebarItemProps) {
  return (
    <Button
      onClick={onClick}
      className="w-full flex justify-between items-center px-4 py-4 hover:bg-[#1f1f1f]"
    >
      <div className="flex items-center gap-3">
        {faIcon && <FontAwesomeIcon icon={faIcon} />}
        {imgSrc && <img src={imgSrc} alt={label} className="w-8 h-8" />}
        <span>{label}</span>
      </div>
      {showArrow && (
        <FontAwesomeIcon icon={faChevronRight} className="text-gray-400" />
      )}
    </Button>
  );
}
